import React from "react";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  TEXT_ADDONS,
  TEXT_BEDDING,
  TEXT_DELIVERED_ON_PICKUP,
  TEXT_DRINKING_WATER,
  TEXT_OPTIONAL,
  TEXT_SELECT_ADDONS,
} from "../../../utils/useConstants";
import { STATE_CONSTANTS_PROGRAM } from "../../../utils/useConstantState";
import { useIsMobile } from "../../../utils/useIsMobile";

import {
  STYLE_HEAD_MEDIUM,
  STYLE_PARENT_GRID_ADDONS,
  STYLE_TEXT_SIZE_SMALL,
  STYLE_TITLE_ADDONS,
} from "../../../utils/useStyle";
import ProgramAddons from "./Program.Addons";

const ProgramSelectAddons = ({
  type,
  addOn,
  setAddOn,
  extras,
  setExtras,
  water,
  setWater,
  tab,
}) => {
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();

  const isCloseExtras = extras?.every((row) => row?.status === false);
  const isCloseWater = water?.every((row) => row?.status === false);

  return (
    <React.Fragment>
      {type !== STATE_CONSTANTS_PROGRAM.MY_DRY && (
        <div className={`${STYLE_HEAD_MEDIUM(language)}`}>
          {isMobile ? (
            <div className=" h-10 md:mb-2">
              {TEXT_ADDONS[language]}{" "}
              <span className={`${STYLE_TEXT_SIZE_SMALL(language)} `}>
                ({TEXT_OPTIONAL[language]})
              </span>
            </div>
          ) : (
            <div className="h-10 ">
              {TEXT_SELECT_ADDONS[language]}
              <span className={`${STYLE_TEXT_SIZE_SMALL(language)} ml-1`}>
                ({TEXT_OPTIONAL[language]})
              </span>
            </div>
          )}

          {isMobile ? (
            <div className={STYLE_PARENT_GRID_ADDONS}>
              {addOn
                ?.sort((a, b) => {
                  return a.index - b.index;
                })
                ?.filter((i) => {
                  if (type === STATE_CONSTANTS_PROGRAM.MY_WASH) {
                    return i.index % 2 === 1;
                  } else {
                    return i.index % 2 === 0;
                  }
                })
                ?.map((row, index) => {
                  if (row?.status) {
                    return (
                      <ProgramAddons
                        type={type}
                        key={index}
                        row={row}
                        setSelect={setAddOn}
                        size={String(tab?.size || "s").toLocaleLowerCase()}
                      />
                    );
                  }
                })}
              {addOn
                ?.sort((a, b) => {
                  return a.index - b.index;
                })
                ?.filter((i) => {
                  if (type === STATE_CONSTANTS_PROGRAM.MY_WASH) {
                    return i.index % 2 === 0;
                  } else {
                    return i.index % 2 === 1;
                  }
                })
                ?.map((row, index) => {
                  if (row?.status) {
                    return (
                      <ProgramAddons
                        type={type}
                        key={index}
                        row={row}
                        setSelect={setAddOn}
                        size={String(tab?.size || "s").toLocaleLowerCase()}
                      />
                    );
                  }
                })}
            </div>
          ) : (
            <div className={STYLE_PARENT_GRID_ADDONS}>
              {addOn
                ?.sort((a, b) => {
                  return a.index - b.index;
                })
                // ?.sort((a, b) => {
                //   return a.index - b.index;
                // })
                ?.map((row, index) => {
                  if (row?.status) {
                    return (
                      <ProgramAddons
                        type={type}
                        key={index}
                        row={row}
                        setSelect={setAddOn}
                        size={String(tab?.size || "s").toLocaleLowerCase()}
                      />
                    );
                  }
                })}
            </div>
          )}
        </div>
      )}
      <div>
        {type !== STATE_CONSTANTS_PROGRAM.MY_DRY &&
          type !== STATE_CONSTANTS_PROGRAM.MY_SHOE && (
            <React.Fragment>
              {!isCloseExtras && (
                <React.Fragment>
                  <div className={STYLE_TITLE_ADDONS(language)}>
                    {TEXT_BEDDING[language]}
                  </div>
                  {isMobile ? (
                    <React.Fragment>
                      <div className={STYLE_PARENT_GRID_ADDONS}>
                        {extras
                          ?.sort((a, b) => {
                            return a.index - b.index;
                          })

                          ?.map((row, index) => {
                            if (row?.status) {
                              return (
                                <ProgramAddons
                                  type={type}
                                  key={index}
                                  row={row}
                                  setSelect={setExtras}
                                />
                              );
                            }
                          })}
                      </div>
                      {/* {type === "My Iron" ? (
                        <div className={STYLE_PARENT_GRID_ADDONS}>
                          {extras
                            ?.sort((a, b) => {
                              return a.index - b.index;
                            })

                            ?.map((row, index) => {
                              if (row?.status) {
                                return (
                                  <ProgramAddons
                                    type={type}
                                    key={index}
                                    row={row}
                                    setSelect={setExtras}
                                  />
                                );
                              }
                            })}
                        </div>
                      ) : (
                        <div className={STYLE_PARENT_GRID_ADDONS}>
                          {extras
                            ?.sort((a, b) => {
                              return a.index - b.index;
                            })
                            ?.filter((_, i) => {
                              return i % 2 === 0;
                            })
                            ?.map((row, index) => {
                              if (row?.status) {
                                return (
                                  <ProgramAddons
                                    type={type}
                                    key={index}
                                    row={row}
                                    setSelect={setExtras}
                                  />
                                );
                              }
                            })}
                          {extras
                            ?.sort((a, b) => {
                              return a.index - b.index;
                            })
                            ?.filter((_, i) => {
                              return i % 2 === 1;
                            })
                            ?.map((row, index) => {
                              if (row?.status) {
                                return (
                                  <ProgramAddons
                                    type={type}
                                    key={index}
                                    row={row}
                                    setSelect={setExtras}
                                  />
                                );
                              }
                            })}
                        </div>
                      )} */}
                    </React.Fragment>
                  ) : (
                    <div className={STYLE_PARENT_GRID_ADDONS}>
                      {extras
                        ?.sort((a, b) => {
                          return a.index - b.index;
                        })
                        ?.map((row, index) => {
                          if (row?.status) {
                            return (
                              <ProgramAddons
                                type={type}
                                key={index}
                                row={row}
                                setSelect={setExtras}
                              />
                            );
                          }
                        })}
                    </div>
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          )}
      </div>
      {!isCloseWater && (
        <div>
          <div className={STYLE_TITLE_ADDONS(language)}>
            {TEXT_DRINKING_WATER[language]}
            <span
              className={`${STYLE_TEXT_SIZE_SMALL(language)} | ml-1 | ${
                language === "EN" ? "mb-0.5 " : " mb-1 "
              }`}
            >
              ({TEXT_DELIVERED_ON_PICKUP[language]})
            </span>
          </div>

          {isMobile ? (
            <div className={STYLE_PARENT_GRID_ADDONS}>
              {water
                ?.filter((_, i) => {
                  return i % 2 === 0;
                })
                ?.map((row, index) => {
                  if (row?.status) {
                    return (
                      <ProgramAddons
                        key={index}
                        row={row}
                        setSelect={setWater}
                        type={type}
                      />
                    );
                  }
                })}
              {water
                ?.filter((_, i) => {
                  return i % 2 === 1;
                })
                ?.map((row, index) => {
                  if (row?.status) {
                    return (
                      <ProgramAddons
                        key={index}
                        row={row}
                        setSelect={setWater}
                        type={type}
                      />
                    );
                  }
                })}
            </div>
          ) : (
            <div className={STYLE_PARENT_GRID_ADDONS}>
              {water?.map((row, index) => {
                if (row?.status) {
                  return (
                    <ProgramAddons
                      key={index}
                      row={row}
                      setSelect={setWater}
                      type={type}
                    />
                  );
                }
              })}
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default ProgramSelectAddons;
